import { TSkillObject } from "../../../services/api/instances/skillsApi/types";
import i18n from "../../../services/i18n";
import { generateId } from "../../../shared/utils/generateId";
import { SKILL_BASE_FIELD } from "../constants";
import { TSkillField } from "../types";

export const generateSkillFields = (
  skill: TSkillObject | null | undefined,
): TSkillField[] => {
  if (!skill) return SKILL_BASE_FIELD;
  const { tags, path, files, friendly_name, metadata, ...rest } = skill;
  const entires = Object.entries(rest);

  const result = entires.map(([key, value]) => {
    const label =
      key === "name"
        ? i18n.t("skills.name_label")
        : key === "description"
          ? i18n.t("skills.description_label")
          : i18n.t("skills.instruction_label");
    const rows = key === "description" ? 5 : key === "instruction" ? 30 : 0;

    return {
      id: generateId(),
      label,
      placeholder: `${i18n.t("skills.input_placeholder")}`,
      value,
      rows,
    };
  });

  if (metadata) {
    const metadataEntires = Object.entries(metadata);
    const metadataResult = metadataEntires.map(([key, value]) => ({
      id: generateId(),
      label: key,
      placeholder: `${i18n.t("skills.input_placeholder")} ${key}`,
      value,
      parent: "metadata",
      inStorageObject: true,
    }));

    return [...result, ...metadataResult];
  }

  return result;
};
